import {etsySettings} from '@coolcolduk/etsy';
import {z} from 'zod';

export const zEtsySku = z.string().max(etsySettings.listing.sku.maxLength);
